@if (spec(); as spec) {
  @switch (spec.domain) {
    @case (JobSpecDomain.INGESTION) {
      @if (spec.ingestion) {
        <span class="text-body-small">{{ spec.ingestion.type }}</span>
      }
    }
    @case (JobSpecDomain.PRODUCTION) {
      @if (spec.production) {
        <span class="text-body-small">{{ spec.production }}</span>
      }
    }
  }
}
